module.exports = __webpack_public_path__ + "img/Image3@2x.83ffb20f.jpg";